import { createApp } from 'vue';

import ConsumerTestimonialsCarousel from './consumerTestimonialsCarousel.vue';

import './consumerTestimonialsImage.scss';
import 'Features/Shared/Views/CaptionLocalBlock/CaptionLocalBlock-entry.scss';

const consumerTestimonialsImageBlocks = document.querySelectorAll<HTMLElement>(
	'[data-feature="consumerTestimonialsImage"]',
);

consumerTestimonialsImageBlocks.forEach((consumerTestimonialsImageBlock) => {
	const app = createApp({
		name: 'ConsumerTestimonialsImageApp',
	});

	app.component(
		'consumer-testimonials-carousel',
		ConsumerTestimonialsCarousel,
	);
	app.mount(consumerTestimonialsImageBlock);
});
